import React, { Component } from "react";
import { Input, Select } from "antd";
import { connect } from "react-redux";
import { WebsitePagesItem } from "../../store/websitePages/types";

const { Option } = Select;

// Select values. A page is stored as a site path ("/thanks"), which the server
// resolves against the website's host (websites/stripe_checkout.py:_return_url),
// so it keeps working after a custom domain is attached.
const DEFAULT_VALUE = "__default__";
const CUSTOM_VALUE = "__custom__";

const pagePath = (page: WebsitePagesItem) => "/" + (page.url || "");

interface Props {
  value: string;
  websiteId: number;
  defaultLabel: string;
  customPlaceholder: string;
  onSave: (value: string) => void;
  pages: WebsitePagesItem[];
}

interface State {
  isCustom: boolean;
  customValue: string;
}

class StripeReturnUrlInput extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const value = props.value || "";
    this.state = {
      isCustom: value !== "" && !this.findPage(value),
      customValue: value,
    };
  }

  websitePages = () =>
    this.props.pages.filter(
      (page) => page.website === this.props.websiteId && !page.is_deleted
    );

  findPage = (value: string) =>
    this.websitePages().find((page) => pagePath(page) === value);

  handleSelect = (selected: string) => {
    if (selected === CUSTOM_VALUE) {
      this.setState({ isCustom: true });
      return;
    }
    this.setState({ isCustom: false });
    this.props.onSave(selected === DEFAULT_VALUE ? "" : selected);
  };

  render() {
    const value = this.props.value || "";
    let selected = DEFAULT_VALUE;
    if (this.state.isCustom) {
      selected = CUSTOM_VALUE;
    } else if (value !== "") {
      selected = value;
    }

    return (
      <div>
        <Select
          showSearch
          style={{ width: "100%" }}
          value={selected}
          onChange={this.handleSelect}
          optionFilterProp="children"
        >
          <Option value={DEFAULT_VALUE}>{this.props.defaultLabel}</Option>
          {this.websitePages().map((page) => (
            <Option key={page.id} value={pagePath(page)}>
              {pagePath(page)}
            </Option>
          ))}
          <Option value={CUSTOM_VALUE}>Custom URL…</Option>
        </Select>
        {this.state.isCustom && (
          <Input
            style={{ marginTop: 10 }}
            placeholder={this.props.customPlaceholder}
            value={this.state.customValue}
            onChange={(e) => this.setState({ customValue: e.target.value })}
            onBlur={() => this.props.onSave(this.state.customValue.trim())}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ websitesPages }) => ({
  pages: websitesPages.items,
});

export default connect(mapStateToProps)(StripeReturnUrlInput);
